import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
// Initialize Firebase
  var config = {
    apiKey: "AIzaSyAHC1ggwvNhcPPHu8WGFah4pjZuEVmk2-s",
    authDomain: "exchnage-content.firebaseapp.com",
    databaseURL: "https://exchnage-content.firebaseio.com",
    projectId: "exchnage-content",
    storageBucket: "exchnage-content.appspot.com",
    messagingSenderId: "548683070744"
  };
  firebase.initializeApp(config);

  firebase.firestore().settings({ timestampsInSnapshots: true })
  
  export default firebase;